import React from "react";
import Header from "./components/Header";
import WelcomePage from "./components/WelcomePage";
// import Home from "./components/Home";
import Basics from "./components/Basics";
import QuickGuide from "./components/QuickGuide";
import Flexbox from "./components/Flexbox";
import CSSGRID from "./components/CSSGrid";
import Styling from "./components/Styling";
import Examples from "./components/Examples";
import Animation from "./components/Animation";
import Mobile from "./components/Mobile";

import PseudoClasses from "./components/PseudoClasses";
import PseudoElements from "./components/PseudoElements";
import PseudoSelectors from "./components/PseudoSelectors";

// import AnimatedCursor from "react-animated-cursor";
import { Link, Routes, Route } from "react-router-dom";

function App() {
  // console.log(AnimatedCursor);
  return (
    <div>
      <Header />
      {/* cursor */}
      {/* <div className="animated-cursor">
        <AnimatedCursor
          color="220, 90, 90"
          outerAlpha={0.4}
          innerSize={8}
          outerSize={8}
          innerScale={0.7}
          outerScale={0.5}
          outerStyle={{
            border: "3px solid #fff",
          }}
          trailingSpeed={8}
        />
      </div> */}
      <Routes>
        {/* <Route path="/" element={<Home />}></Route>

        <Route path="/home" element={<Home />}></Route> */}

        <Route path="/" element={<WelcomePage />}></Route>

        <Route path="/home" element={<WelcomePage />}></Route>

        <Route path="/basics" element={<Basics />}></Route>

        <Route path="/cssgrid" element={<CSSGRID />}></Route>

        <Route path="/flexbox" element={<Flexbox />}></Route>

        <Route path="/quicktips" element={<QuickGuide />}></Route>

        <Route path="/examples" element={<Examples />}></Route>

        <Route path="/styling" element={<Styling />}></Route>

        <Route path="/animation" element={<Animation />}></Route>

        <Route path="/mobile" element={<Mobile />}></Route>

        <Route path="/pseudoclasses" element={<PseudoClasses />}></Route>

        <Route path="/pseudoelements" element={<PseudoElements />}></Route>

        <Route path="/pseudoselectors" element={<PseudoSelectors />}></Route>

        {/* end of routes*/}
      </Routes>
    </div>
  );
}

export default App;
